export default __webpack_public_path__ + "static/media/bcpd11.f7030257.png";